import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { PageableResponse } from "../PageableResponse";

export type B000120FindRequest = Partial<{
  eigyoCdFrom: string;
  eigyoCdTo: string;
  name: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000120FindResponse = {
  eigyoCd: string;
  eigyoNm: string;
  eigyoKana: string;
  eigyoNmr: string;
  telNo: string;
  faxNo: string;
  denpyoinji1: string;
  denpyoinji2: string;
  denpyoinji3: string;
  denpyoinji4: string;
  denpyoinji5: string;
  ginkoCd1: string;
  ginkoshitenCd1: string;
  kozashubetsu1: number;
  kozabango1: string;
  ginkoCd2: string;
  ginkoshitenCd2: string;
  kozashubetsu2: number;
  kozabango2: string;
};

export const B000120Find = (props: B000120FindRequest) => {
  return RestClient.get<PageableResponse<B000120FindResponse>>("b000120/find", {
    params: props,
  });
};

export type B000120GetRequest = {
  eigyoCd: string;
};

export const B000120Get = (props: B000120GetRequest) => {
  return RestClient.get("b000120/get", {
    params: props,
  });
};

//営業所名略表示
export const B000120EigyoNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.eigyoCd === "") {
    methods.setValue("eigyoNmr", data.eigyoCd);
    return;
  }
  await B000120Get({ eigyoCd: data.eigyoCd })
    .then((response) => {
      methods.setValue("eigyoNmr", response.data.eigyoNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("eigyoNmr", "");
    });
};

//営業所名表示
export const B000120EigyoNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.eigyoCd === "") {
    methods.setValue("eigyoNm", data.eigyoCd);
    return;
  }
  await B000120Get({ eigyoCd: data.eigyoCd })
    .then((response) => {
      methods.setValue("eigyoNm", response.data.eigyoNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("eigyoNm", "");
    });
};

//営業所名(From)表示
export const B000120EigyoNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.eigyoCdFrom === "") {
    methods.setValue("eigyoNmFrom", data.eigyoCdFrom);
    return;
  }
  await B000120Get({ eigyoCd: data.eigyoCdFrom })
    .then((response) => {
      methods.setValue("eigyoNmFrom", response.data.eigyoNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("eigyoNmFrom", "");
    });
};

//営業所名(To)表示
export const B000120EigyoNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.eigyoCdTo === "") {
    methods.setValue("eigyoNmTo", data.eigyoCdTo);
    return;
  }
  await B000120Get({ eigyoCd: data.eigyoCdTo })
    .then((response) => {
      methods.setValue("eigyoNmTo", response.data.eigyoNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("eigyoNmTo", "");
    });
};
